import React, { Component } from "react";
import axios from "axios";
import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";

const toDateTimeLocal = (value) => {
  if (!value) {
    return "";
  }

  const date = new Date(value);
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60000);
  return localDate.toISOString().slice(0, 16);
};

export default class UpdateLiveTest extends Component {
  state = {
    id: "",
    title: "",
    payment_type: "free",
    negative_marking: "no",
    negative_marking_value: "",
    price: "",
    offer_price: "",
    prize_pool: "",
    default_question_time_seconds: 30,
    start_time: "",
    end_time: "",
    status: "active",
    show_full_image_in_app: "false",
    live_test_status: "upcoming",
    instructions: "",
    syllabus: "",
    small_poster: null,
    large_poster: null,
    loading: false,
    notification: false,
    message: "",
    redirect: false,
  };

  componentDidMount() {
    const id = window.location.pathname.split("/")[2];
    this.setState({ id }, this.getLiveTestDetails);
  }

  getLiveTestDetails = async () => {
    try {
      if (init() === "success") {
        const resp = await axios.get(`${Constants.getUrls.getSingleLiveTest}${this.state.id}`);
        const data = resp?.data?.data || {};
        this.setState({
          title: data.title || data.test_name || "",
          payment_type: data.payment_type || "free",
          negative_marking: data.negative_marking || "no",
          negative_marking_value: data.negative_marking_value || "",
          price: data.price || "",
          offer_price: data.offer_price || "",
          prize_pool: data.prize_pool || "",
          default_question_time_seconds: data.default_question_time_seconds || 30,
          start_time: toDateTimeLocal(data.start_time),
          end_time: toDateTimeLocal(data.end_time),
          status: data.status || "active",
          show_full_image_in_app: data.show_full_image_in_app === true ? "true" : "false",
          live_test_status: data.live_test_status || "upcoming",
          instructions: data.instructions || "",
          syllabus: data.syllabus || "",
        });
      }
    } catch (err) {
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Failed to load live test.",
      });
    }
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleFile = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();

    Object.entries({
      title: this.state.title,
      payment_type: this.state.payment_type,
      negative_marking: this.state.negative_marking,
      negative_marking_value: this.state.negative_marking_value || 0,
      price: this.state.price || 0,
      offer_price: this.state.offer_price || 0,
      prize_pool: this.state.prize_pool || 0,
      default_question_time_seconds: this.state.default_question_time_seconds,
      start_time: this.state.start_time,
      end_time: this.state.end_time,
      status: this.state.status,
      show_full_image_in_app: this.state.show_full_image_in_app,
      live_test_status: this.state.live_test_status,
      instructions: this.state.instructions,
      syllabus: this.state.syllabus,
    }).forEach(([key, value]) => fd.append(key, value));

    if (this.state.small_poster) {
      fd.append("small_poster", this.state.small_poster);
    }

    if (this.state.large_poster) {
      fd.append("large_poster", this.state.large_poster);
    }

    this.setState({ loading: true });

    try {
      const resp = await axios.put(`${Constants.putUrls.updateLiveTest}${this.state.id}`, fd);
      this.setState({
        loading: false,
        notification: true,
        message: resp.data.message,
      });
      setTimeout(() => {
        this.setState({ redirect: true });
      }, 1500);
    } catch (err) {
      this.setState({
        loading: false,
        notification: true,
        message: err?.response?.data?.message || "Failed to update live test.",
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/live-tests" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Edit Live Test
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <InputLabel>Live Test Title</InputLabel>
                    <TextField
                      name="title"
                      value={this.state.title}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InputLabel>Entry Type</InputLabel>
                    <Select
                      name="payment_type"
                      value={this.state.payment_type}
                      onChange={this.handleInput}
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="free">Free</MenuItem>
                      <MenuItem value="paid">Paid</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InputLabel>Question Timer (sec)</InputLabel>
                    <TextField
                      type="number"
                      name="default_question_time_seconds"
                      value={this.state.default_question_time_seconds}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InputLabel>Negative Marking</InputLabel>
                    <Select
                      name="negative_marking"
                      value={this.state.negative_marking}
                      onChange={this.handleInput}
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="no">No</MenuItem>
                      <MenuItem value="yes">Yes</MenuItem>
                    </Select>
                  </Grid>
                  {this.state.negative_marking === "yes" ? (
                    <Grid item xs={12} md={3}>
                      <InputLabel>Deduction Per Wrong</InputLabel>
                      <TextField
                        type="number"
                        name="negative_marking_value"
                        value={this.state.negative_marking_value}
                        onChange={this.handleInput}
                        style={{ width: "100%" }}
                        required
                      />
                    </Grid>
                  ) : null}
                  <Grid item xs={12} md={3}>
                    <InputLabel>Live Status</InputLabel>
                    <Select
                      name="live_test_status"
                      value={this.state.live_test_status}
                      onChange={this.handleInput}
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="upcoming">Upcoming</MenuItem>
                      <MenuItem value="live">Live</MenuItem>
                      <MenuItem value="completed">Completed</MenuItem>
                      <MenuItem value="cancelled">Cancelled</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InputLabel>Status</InputLabel>
                    <Select
                      name="status"
                      value={this.state.status}
                      onChange={this.handleInput}
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InputLabel>App Card Layout</InputLabel>
                    <Select
                      name="show_full_image_in_app"
                      value={this.state.show_full_image_in_app}
                      onChange={this.handleInput}
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="false">Standard Card</MenuItem>
                      <MenuItem value="true">Full Image Card</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel>Start Time</InputLabel>
                    <TextField
                      type="datetime-local"
                      name="start_time"
                      value={this.state.start_time}
                      onChange={this.handleInput}
                      InputLabelProps={{ shrink: true }}
                      style={{ width: "100%" }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel>End Time</InputLabel>
                    <TextField
                      type="datetime-local"
                      name="end_time"
                      value={this.state.end_time}
                      onChange={this.handleInput}
                      InputLabelProps={{ shrink: true }}
                      style={{ width: "100%" }}
                      required
                    />
                  </Grid>
                  {this.state.payment_type === "paid" ? (
                    <>
                      <Grid item xs={12} md={4}>
                        <InputLabel>Price</InputLabel>
                        <TextField
                          type="number"
                          name="price"
                          value={this.state.price}
                          onChange={this.handleInput}
                          style={{ width: "100%" }}
                          required
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <InputLabel>Offer Price</InputLabel>
                        <TextField
                          type="number"
                          name="offer_price"
                          value={this.state.offer_price}
                          onChange={this.handleInput}
                          style={{ width: "100%" }}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <InputLabel>Prize Pool</InputLabel>
                        <TextField
                          type="number"
                          name="prize_pool"
                          value={this.state.prize_pool}
                          onChange={this.handleInput}
                          style={{ width: "100%" }}
                        />
                      </Grid>
                    </>
                  ) : null}
                  <Grid item xs={12} md={6}>
                    <InputLabel>Replace Small Image</InputLabel>
                    <TextField
                      type="file"
                      name="small_poster"
                      onChange={this.handleFile}
                      inputProps={{ accept: "image/*" }}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel>Replace Large Image</InputLabel>
                    <TextField
                      type="file"
                      name="large_poster"
                      onChange={this.handleFile}
                      inputProps={{ accept: "image/*" }}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel>Instructions</InputLabel>
                    <TextField
                      multiline
                      minRows={3}
                      name="instructions"
                      value={this.state.instructions}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel>Syllabus</InputLabel>
                    <TextField
                      multiline
                      minRows={3}
                      name="syllabus"
                      value={this.state.syllabus}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                </Grid>

                <Grid align="left" mt={2}>
                  <MDButton variant="contained" size="small" color="info" type="submit">
                    {this.state.loading ? "Updating..." : "Update Live Test"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color="success"
              icon="notifications"
              title="AgriQuiz"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
